var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassPanel",
    {
      staticClass: "objective-update-panel",
      attrs: {
        value: _vm.isVisible,
        title: _vm.localizes.title,
        size: "large"
      },
      on: { beforeClose: _vm.closePanel, closed: _vm.closePanel }
    },
    [
      _c("div", { staticClass: "objective-update-panel__heading" }, [
        _c(
          "h2",
          {
            staticClass:
              "objective-update-panel__heading-title typographies-heading-h2"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Définissez votre objectif")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "objective-update-panel__content" },
        [
          _c(
            "CompassFormItem",
            {
              staticClass: "objective-update-panel__content-name",
              attrs: {
                label: _vm.localizes.form.name,
                size: "small",
                orientation: "horizontal"
              }
            },
            [
              _c("CompassInput", {
                attrs: {
                  placeholder: _vm.localizes.form.placeholder.name,
                  size: "small"
                },
                model: {
                  value: _vm.updatedObjective.name,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedObjective, "name", $$v)
                  },
                  expression: "updatedObjective.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassDescriptionList",
            {
              staticClass: "objective-update-panel__content-category",
              attrs: { type: "alternative" }
            },
            [
              _c(
                "CompassDescriptionListItem",
                { attrs: { label: _vm.localizes.form.category } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.objective.category.label) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CompassDescriptionList",
            {
              staticClass: "objective-update-panel__content-main-informations",
              attrs: { type: "alternative" }
            },
            [
              _c(
                "CompassDescriptionListItem",
                { attrs: { label: _vm.localizes.form.assignee } },
                [
                  _c(
                    "CompassAvatarName",
                    {
                      attrs: {
                        size: "small",
                        firstname: _vm.assigneeFormated.firstname,
                        lastname: _vm.assigneeFormated.lastname,
                        showCaption: false
                      }
                    },
                    [
                      _c("CompassAvatar", {
                        attrs: {
                          size: "small",
                          colorType: _vm.assigneeFormated.colorType,
                          initials: _vm.assigneeFormated.initials,
                          type: _vm.assigneeFormated.type
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.itemFormated
                ? _c(
                    "CompassDescriptionListItem",
                    { attrs: { label: _vm.localizes.form.item } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.itemFormated) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "CompassDescriptionListItem",
                {
                  staticClass:
                    "objective-update-panel__content-main-informations-period",
                  attrs: { label: _vm.localizes.form.duration }
                },
                [
                  _c("CompassIcon", { attrs: { icon: "calendar-fill" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.durationFormated) +
                      "\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassDescriptionListItem",
                {
                  staticClass:
                    "objective-update-panel__content-main-informations-period",
                  attrs: { label: _vm.localizes.form.period }
                },
                [
                  _c("CompassIcon", { attrs: { icon: "calendar-fill" } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.periodFormated) +
                      "\n            "
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hasRefinements
            ? _c(
                "CompassFormItem",
                {
                  staticClass:
                    "objective-update-panel__content-result-editable",
                  attrs: {
                    label: _vm.localizes.form.result,
                    size: "small",
                    orientation: "horizontal"
                  }
                },
                [
                  _c("AmountInputFormated", {
                    attrs: {
                      placeholder: _vm.localizes.form.placeholder.result,
                      currencySymbol: _vm.objectiveCurrencySymbol,
                      size: "small"
                    },
                    model: {
                      value: _vm.updatedObjective.turnover.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.updatedObjective.turnover, "amount", $$v)
                      },
                      expression: "updatedObjective.turnover.amount"
                    }
                  }),
                  _vm._v(" "),
                  _vm.hasPreviousTurnover && !_vm.isComputeLoading
                    ? _c("div", { staticClass: "objective-previous-datas" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "objective-previous-datas__amount typographies-paragraph-small-semibold"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.previousTurnoverAmountFormated) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "objective-previous-datas__period typographies-paragraph-small-regular"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.previousTurnoverYear) +
                                "\n                "
                            )
                          ]
                        )
                      ])
                    : _vm.isComputeLoading
                    ? _c("CompassSkeleton", {
                        staticClass: "objective-previous-datas"
                      })
                    : _vm._e()
                ],
                1
              )
            : [
                _c(
                  "div",
                  { staticClass: "objective-update-panel__content-result" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "objective-update-panel__content-result-label typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$l10n.__("Résultat attendu ajusté")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "objective-update-panel__content-result-amount typographies-paragraph-x-large-semibold"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.turnoverAmountAdjustedFormated) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasPreviousTurnover && !_vm.isComputeLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "objective-update-panel__content-result-previous"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "objective-previous-datas__amount typographies-paragraph-small-semibold"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.previousTurnoverAmountFormated) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "objective-previous-datas__period typographies-paragraph-small-regular"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.previousTurnoverYear) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm.isComputeLoading
                      ? _c("CompassSkeleton", {
                          staticClass:
                            "objective-update-panel__content-result-previous"
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "objective-update-panel__content-refinements"
                  },
                  _vm._l(_vm.updatedObjective.refinements, function(
                    refinement
                  ) {
                    return _c(
                      "div",
                      {
                        key: refinement.period.date_start,
                        staticClass:
                          "objective-update-panel__content-refinements-item"
                      },
                      [
                        _c(
                          "CompassFormItem",
                          {
                            attrs: {
                              label: _vm.getRefinementLabel(refinement),
                              size: "small"
                            }
                          },
                          [
                            _c("AmountInputFormated", {
                              attrs: {
                                currencySymbol: _vm.objectiveCurrencySymbol,
                                placeholder:
                                  _vm.localizes.form.placeholder.refinement,
                                disabled: !refinement.isEditable,
                                size: "small"
                              },
                              model: {
                                value: refinement.turnover.amount,
                                callback: function($$v) {
                                  _vm.$set(refinement.turnover, "amount", $$v)
                                },
                                expression: "refinement.turnover.amount"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasPreviousRefinements &&
                        _vm.getPreviousRefinement(refinement) &&
                        !_vm.isComputeLoading
                          ? _c(
                              "div",
                              { staticClass: "objective-previous-datas" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "objective-previous-datas__amount typographies-paragraph-small-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.getPreviousRefinement(refinement)
                                            .amount
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "objective-previous-datas__period typographies-paragraph-small-regular"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.getPreviousRefinement(refinement)
                                            .period
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm.isComputeLoading
                          ? _c("CompassSkeleton", {
                              staticClass: "objective-previous-datas"
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "objective-update-panel__footer" },
          [
            _c("CompassButton", {
              attrs: { label: _vm.localizes.buttons.cancel, type: "secondary" },
              on: { click: _vm.closePanel }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.localizes.buttons.save,
                loading: _vm.isSaveButtonLoading
              },
              on: { click: _vm.updateObjective }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }